import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.sort.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import { LRUCache, TernarySearchTree } from '../../../base/common/map.js';
import { IStorageService, WillSaveStateReason } from '../../../platform/storage/common/storage.js';
import { completionKindFromString } from '../../common/modes.js';
import { DisposableStore } from '../../../base/common/lifecycle.js';
import { RunOnceScheduler } from '../../../base/common/async.js';
import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
import { IConfigurationService } from '../../../platform/configuration/common/configuration.js';
import { registerSingleton } from '../../../platform/instantiation/common/extensions.js';
import { IModeService } from '../../common/services/modeService.js';
export var Memory = /*#__PURE__*/function () {
  function Memory(name) {
    _classCallCheck(this, Memory);

    this.name = name;
  }

  _createClass(Memory, [{
    key: "select",
    value: function select(model, pos, items) {
      if (items.length === 0) {
        return 0;
      }

      var topScore = items[0].score[0];

      for (var i = 0; i < items.length; i++) {
        var _items$i = items[i],
            score = _items$i.score,
            suggestion = _items$i.completion;

        if (score[0] !== topScore) {
          // stop when leaving the group of top matches
          break;
        }

        if (suggestion.preselect) {
          // stop when seeing an auto-select-item
          return i;
        }
      }

      return 0;
    }
  }]);

  return Memory;
}();
export var NoMemory = /*#__PURE__*/function (_Memory) {
  _inherits(NoMemory, _Memory);

  var _super = _createSuper(NoMemory);

  function NoMemory() {
    _classCallCheck(this, NoMemory);

    return _super.call(this, 'first');
  }

  _createClass(NoMemory, [{
    key: "memorize",
    value: function memorize(model, pos, item) {// no-op
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return undefined;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON() {//
    }
  }]);

  return NoMemory;
}(Memory);
export var LRUMemory = /*#__PURE__*/function (_Memory2) {
  _inherits(LRUMemory, _Memory2);

  var _super2 = _createSuper(LRUMemory);

  function LRUMemory() {
    var _this;

    _classCallCheck(this, LRUMemory);

    _this = _super2.call(this, 'recentlyUsed');
    _this._cache = new LRUCache(300, 0.66);
    _this._seq = 0;
    return _this;
  }

  _createClass(LRUMemory, [{
    key: "memorize",
    value: function memorize(model, pos, item) {
      var label = item.completion.label;
      var key = "".concat(model.getLanguageIdentifier().language, "/").concat(label);

      this._cache.set(key, {
        touch: this._seq++,
        type: item.completion.kind,
        insertText: item.completion.insertText
      });
    }
  }, {
    key: "select",
    value: function select(model, pos, items) {
      if (items.length === 0) {
        return 0;
      }

      var lineSuffix = model.getLineContent(pos.lineNumber).substr(pos.column - 10, pos.column - 1);

      if (/\s$/.test(lineSuffix)) {
        return _get(_getPrototypeOf(LRUMemory.prototype), "select", this).call(this, model, pos, items);
      }

      var topScore = items[0].score[0];
      var indexPreselect = -1;
      var indexRecency = -1;
      var seq = -1;

      for (var i = 0; i < items.length; i++) {
        if (items[i].score[0] !== topScore) {
          // consider only top items
          break;
        }

        var key = "".concat(model.getLanguageIdentifier().language, "/").concat(items[i].completion.label);

        var item = this._cache.peek(key);

        if (item && item.touch > seq && item.type === items[i].completion.kind && item.insertText === items[i].completion.insertText) {
          seq = item.touch;
          indexRecency = i;
        }

        if (items[i].completion.preselect && indexPreselect === -1) {
          // stop when seeing an auto-select-item
          return indexPreselect = i;
        }
      }

      if (indexRecency !== -1) {
        return indexRecency;
      } else if (indexPreselect !== -1) {
        return indexPreselect;
      } else {
        return 0;
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this._cache.toJSON();
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(data) {
      this._cache.clear();

      var seq = 0;

      var _iterator = _createForOfIteratorHelper(data),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          value.touch = seq;
          value.type = typeof value.type === 'number' ? value.type : completionKindFromString(value.type);

          this._cache.set(key, value);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._seq = this._cache.size;
    }
  }]);

  return LRUMemory;
}(Memory);
export var PrefixMemory = /*#__PURE__*/function (_Memory3) {
  _inherits(PrefixMemory, _Memory3);

  var _super3 = _createSuper(PrefixMemory);

  function PrefixMemory() {
    var _this2;

    _classCallCheck(this, PrefixMemory);

    _this2 = _super3.call(this, 'recentlyUsedByPrefix');
    _this2._trie = TernarySearchTree.forStrings();
    _this2._seq = 0;
    return _this2;
  }

  _createClass(PrefixMemory, [{
    key: "memorize",
    value: function memorize(model, pos, item) {
      var _model$getWordUntilPo = model.getWordUntilPosition(pos),
          word = _model$getWordUntilPo.word;

      var key = "".concat(model.getLanguageIdentifier().language, "/").concat(word);

      this._trie.set(key, {
        type: item.completion.kind,
        insertText: item.completion.insertText,
        touch: this._seq++
      });
    }
  }, {
    key: "select",
    value: function select(model, pos, items) {
      var _model$getWordUntilPo2 = model.getWordUntilPosition(pos),
          word = _model$getWordUntilPo2.word;

      if (!word) {
        return _get(_getPrototypeOf(PrefixMemory.prototype), "select", this).call(this, model, pos, items);
      }

      var key = "".concat(model.getLanguageIdentifier().language, "/").concat(word);

      var item = this._trie.get(key);

      if (!item) {
        item = this._trie.findSubstr(key);
      }

      if (item) {
        for (var i = 0; i < items.length; i++) {
          var _items$i$completion = items[i].completion,
              kind = _items$i$completion.kind,
              insertText = _items$i$completion.insertText;

          if (kind === item.type && insertText === item.insertText) {
            return i;
          }
        }
      }

      return _get(_getPrototypeOf(PrefixMemory.prototype), "select", this).call(this, model, pos, items);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var entries = [];

      this._trie.forEach(function (value, key) {
        return entries.push([key, value]);
      }); // sort by last recently used (touch), then
      // take the top 200 item and normalize their
      // touch


      entries.sort(function (a, b) {
        return -(a[1].touch - b[1].touch);
      }).forEach(function (value, i) {
        return value[1].touch = i;
      });
      return entries.slice(0, 200);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(data) {
      this._trie.clear();

      if (data.length > 0) {
        this._seq = data[0][1].touch + 1;

        var _iterator2 = _createForOfIteratorHelper(data),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 2),
                key = _step2$value[0],
                value = _step2$value[1];

            value.type = typeof value.type === 'number' ? value.type : completionKindFromString(value.type);

            this._trie.set(key, value);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }]);

  return PrefixMemory;
}(Memory);

var SuggestMemoryService = /*#__PURE__*/function () {
  function SuggestMemoryService(_storageService, _modeService, _configService) {
    var _this3 = this;

    _classCallCheck(this, SuggestMemoryService);

    this._storageService = _storageService;
    this._modeService = _modeService;
    this._configService = _configService;
    this._disposables = new DisposableStore();
    this._persistSoon = new RunOnceScheduler(function () {
      return _this3._saveState();
    }, 500);

    this._disposables.add(_storageService.onWillSaveState(function (e) {
      if (e.reason === WillSaveStateReason.SHUTDOWN) {
        _this3._saveState();
      }
    }));
  }

  _createClass(SuggestMemoryService, [{
    key: "dispose",
    value: function dispose() {
      this._disposables.dispose();

      this._persistSoon.dispose();
    }
  }, {
    key: "memorize",
    value: function memorize(model, pos, item) {
      this._withStrategy(model, pos).memorize(model, pos, item);

      this._persistSoon.schedule();
    }
  }, {
    key: "select",
    value: function select(model, pos, items) {
      return this._withStrategy(model, pos).select(model, pos, items);
    }
  }, {
    key: "_withStrategy",
    value: function _withStrategy(model, pos) {
      var _a, _b;

      var mode = this._configService.getValue('editor.suggestSelection', {
        overrideIdentifier: (_a = this._modeService.getLanguageIdentifier(model.getLanguageIdAtPosition(pos.lineNumber, pos.column))) === null || _a === void 0 ? void 0 : _a.language,
        resource: model.uri
      });

      if (((_b = this._strategy) === null || _b === void 0 ? void 0 : _b.name) !== mode) {
        this._saveState();

        var ctor = SuggestMemoryService._strategyCtors.get(mode) || NoMemory;
        this._strategy = new ctor();

        try {
          var share = this._configService.getValue('editor.suggest.shareSuggestSelections');

          var scope = share ? 0
          /* GLOBAL */
          : 1
          /* WORKSPACE */
          ;

          var raw = this._storageService.get("".concat(SuggestMemoryService._storagePrefix, "/").concat(mode), scope);

          if (raw) {
            this._strategy.fromJSON(JSON.parse(raw));
          }
        } catch (e) {// things can go wrong with JSON...
        }
      }

      return this._strategy;
    }
  }, {
    key: "_saveState",
    value: function _saveState() {
      if (this._strategy) {
        var share = this._configService.getValue('editor.suggest.shareSuggestSelections');

        var scope = share ? 0
        /* GLOBAL */
        : 1
        /* WORKSPACE */
        ;
        var raw = JSON.stringify(this._strategy);

        this._storageService.store("".concat(SuggestMemoryService._storagePrefix, "/").concat(this._strategy.name), raw, scope);
      }
    }
  }]);

  return SuggestMemoryService;
}();

SuggestMemoryService._strategyCtors = new Map([['recentlyUsedByPrefix', PrefixMemory], ['recentlyUsed', LRUMemory], ['first', NoMemory]]);
SuggestMemoryService._storagePrefix = 'suggest/memories';
SuggestMemoryService = __decorate([__param(0, IStorageService), __param(1, IModeService), __param(2, IConfigurationService)], SuggestMemoryService);
export { SuggestMemoryService };
export var ISuggestMemoryService = createDecorator('ISuggestMemories');
registerSingleton(ISuggestMemoryService, SuggestMemoryService, true);